import React, { useState } from 'react';
import { Star } from 'lucide-react';
import { Button } from './ui/Button';
export function ReviewForm() {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    // In a real app, this would send data to backend
    setTimeout(() => {
      // Reset after showing success message
      setSubmitted(false);
      setRating(0);
    }, 3000);
  };
  return <div className="bg-slate-900 border border-slate-800 rounded-xl p-6 mt-12" data-id="element-32">
      <h3 className="text-xl font-bold text-white mb-6" data-id="element-33">Deja tu reseña</h3>

      {submitted ? <div className="bg-green-500/20 border border-green-500/30 text-green-400 p-4 rounded-lg text-center animate-in fade-in" data-id="element-34">
          <p className="font-bold" data-id="element-35">¡Gracias por tu comentario!</p>
          <p className="text-sm" data-id="element-36">
            Tu reseña está siendo moderada y aparecerá pronto.
          </p>
        </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-37">
          <div data-id="element-38">
            <label className="block text-sm font-medium text-slate-400 mb-1" data-id="element-39">
              Nombre Completo
            </label>
            <input required type="text" className="w-full bg-slate-950 border border-slate-800 rounded-lg p-3 text-white focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all" placeholder="Tu nombre" data-id="element-40" />
          </div>

          <div data-id="element-41">
            <label className="block text-sm font-medium text-slate-400 mb-1" data-id="element-42">
              Calificación
            </label>
            <div className="flex gap-1" data-id="element-43">
              {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} onClick={() => setRating(star)} className="focus:outline-none transition-transform hover:scale-110" data-id="element-44">
                  <Star className={`w-8 h-8 ${star <= (hoverRating || rating) ? 'text-yellow-500 fill-yellow-500' : 'text-slate-700 fill-slate-700'}`} data-id="element-45" />
                </button>)}
            </div>
          </div>

          <div data-id="element-46">
            <label className="block text-sm font-medium text-slate-400 mb-1" data-id="element-47">
              Escribí tu experiencia
            </label>
            <textarea required rows={4} className="w-full bg-slate-950 border border-slate-800 rounded-lg p-3 text-white focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none transition-all resize-none" placeholder="Contanos qué te pareció el curso..." data-id="element-48" />
          </div>

          <Button type="submit" fullWidth data-id="element-49">
            PUBLICAR RESEÑA
          </Button>
        </form>}
    </div>;
}